import axios from 'utils/axios';
import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  getAll: '/categories/getAll',
  getAllRootCategories: '/categories/getAllRootCategory',
  delete: '/categories/delete/',
  create: '/categories/create',
  update: '/categories/update',
  getBrands: '/categories/getAllBrand',
  getSubCategory: '/subCategory',
  getCategoryById: '/categories',
  uploadCategoryImages: '/categories/uploadCategoryImages'
};

export const getAllCategoriesApi = createAsyncThunk('serviceplug/getAllCategoriesApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getAll);
    if (response.data.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAllRootCategoriesApi = createAsyncThunk(
  'serviceplug/getAllRootCategoriesApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.getAllRootCategories);
      if (response.data.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
export const getSubCategoryListApi = createAsyncThunk('serviceplug/getSubCategoryListApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.getSubCategory}?category=${params.category}`);
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAllBrandsApi = createAsyncThunk('serviceplug/getAllBrandsApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getBrands);
    if (response.data.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const deleteCategoriesApi = createAsyncThunk('serviceplug/deleteCategoriesApi', async (params, thunkApi) => {
  try {
    const response = await axios.delete(`${urls.delete}${params.categoryId}`);
    if (response.data) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const createCategoriesApi = createAsyncThunk('serviceplug/createCategoriesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: urls.create,
      method: 'post',
      data: params
    });
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateCategoriesApi = createAsyncThunk('serviceplug/updateCategoriesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: urls.update,
      method: 'put',
      data: params
    });
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getCategoryByCategoryIdApi = createAsyncThunk(
  'serviceplug/getCategoryByCategoryIdApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(`${urls.getCategoryById}/${params.categoryId}`);
      if (!_.isEmpty(response.data?.result)) {
        return response.data.result[0];
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const uploadCategoryImagesApi = createAsyncThunk('user/uploadCategoryImagesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadCategoryImages}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
